import React, { useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import DatePickerComponent from "./components/DatePicker/DatePicker";
import TickerSearchBox from "./components/TickerSearchBox/TickerSearchBox";
import CorrelationTable from "./components/CorrelationTable/CorrelationTable";
import Button from "react-bootstrap/Button";

const dateToFormat = (date_in) => {
  const date = new Date(date_in);
  return (
    date.getFullYear() +
    "-" +
    parseInt(date.getMonth() + 1) +
    "-" +
    date.getDate()
  );
};

function App() {
  const [correlationTable, setCorrelationTable] = useState([[]]);
  const [start_date, start_date_update] = useState(new Date());
  const [end_date, end_date_update] = useState(new Date());
  const [tickers, setTickers] = useState([]);
  const calculateCorrelation = (event) => {
    const ticker_codes = tickers.map((tick) => tick.value);
    fetch(
      "https://hav8ear3ve.execute-api.ap-south-1.amazonaws.com/default/FinanceCorrelation",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Tickers: ticker_codes,
          start_date: dateToFormat(start_date),
          end_date: dateToFormat(end_date),
        }),
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // const message = response.json().message;
          // console.log();
          throw new Error("Internal Server Error");
        }
      })
      .then((json) => {
        setCorrelationTable(json.correlation);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  return (
    <div className="App">
      <header className="App-header" styles={{ height: 80 }}>
        Correlation Calculator
      </header>
      <div className="App-body">
        <br />
        <TickerSearchBox setTickers={setTickers} />
        <br />
        <DatePickerComponent
          start_date_update={start_date_update}
          end_date_update={end_date_update}
          start_date={start_date}
          end_date={end_date}
        ></DatePickerComponent>
        <br />

        <Button onClick={calculateCorrelation}>Calculate</Button>
        {/* <h3>Correlation : {correlation}</h3> */}
        <CorrelationTable
          tableData={correlationTable}
          tickers={tickers}
        ></CorrelationTable>
      </div>
      <footer className="App-footer"></footer>
    </div>
  );
}

export default App;
